<script>
import bem from '@/utils/bem';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons-vue';

const b = bem('template-frame-option-displays');

const displaysRatio = {
  liveDisplay: 1.71,
  minDisplay: 1.2,
  mobileDisplay: 1.33,
};

const displaysTypes = ['liveDisplay', 'minDisplay', 'mobileDisplay'];

export default {
  components: {
    LockOutlined,
    UnlockOutlined,
  },
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    isRatioLocked: Boolean,
    activeType: Object,
    isInputFocus: Boolean,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    getRatio(width, height) {
      const { type } = this.activeType;
      return displaysRatio[type] || width / height;
    },
    change({ target: { value } }, type) {
      const { type: dataType } = this.activeType;
      const isDisplay = displaysTypes.includes(dataType);
      if ((this.isRatioLocked || isDisplay) && (type === 'width' || type === 'height')) {
        const ratio = this.getRatio(this.width, this.height);
        const newWidth = type === 'width' ? Number(value).toFixed(0) : String(Number(value).toFixed(0) * ratio);
        const newHeight = type === 'height' ? Number(value).toFixed(0) : String(Number(value).toFixed(0) / ratio);
        if (this.isRatioLocked) {
          this.$emit('update:isRatioLocked', false);
        }
        this.$emit('update:width', newWidth);
        this.$emit('update:height', newHeight);
        if (this.isRatioLocked) {
          setTimeout(() => {
            this.$emit('update:isRatioLocked', true);
          }, 50);
        }
      } else {
        this.$emit(`update:${type}`, value);
      }
    },
    changeLocked() {
      this.$emit('update:isRatioLocked', !this.isRatioLocked);
    },
    updateInputFocusStatus(value) {
      const { type: dataType } = this.activeType;
      const isDisplay = displaysTypes.includes(dataType);
      if (isDisplay) {
        if (value) {
          setTimeout(() => {
            this.$emit('update:isRatioLocked', value);
          }, 50);
        }
        this.$emit('update:isInputFocus', value);
      }
    },
  },
};
</script>

<template>
  <div :class="b('modal-input', { row: true })">
    <span :class="b('modal-input-title')">X:</span>
    <a-input
        type="number"
        :value="x"
        @change="(e) => {change(e, 'x')}"
    />
  </div>
  <div :class="b('modal-input', { row: true })">
    <span :class="b('modal-input-title')">Y:</span>
    <a-input
        type="number"
        :value="y"
        @change="(e) => {change(e, 'y')}"
    />
  </div>
  <div :class="b('modal-input', { row: true })">
    <span :class="b('modal-input-title')">Width:</span>
    <a-input
        type="number"
        :value="width"
        @change="(e) => {change(e, 'width')}"
        @focus="() => {updateInputFocusStatus(true)}"
        @blur="() => {updateInputFocusStatus(false)}"
    />

    <div
        :class="b('lock-ratio-btn-wrap')"
        v-if="activeType?.type === 'framePosition'"
    >
      <a-button
          type="text"
          html-type="button"
          @click="changeLocked"
      >
        <LockOutlined v-if="isRatioLocked" />
        <UnlockOutlined v-else />
      </a-button>
    </div>
  </div>
  <div :class="b('modal-input', { row: true })">
    <span :class="b('modal-input-title')">Height:</span>
    <a-input
        type="number"
        :value="height"
        @change="(e) => {change(e, 'height')}"
        @focus="() => {updateInputFocusStatus(true)}"
        @blur="() => {updateInputFocusStatus(false)}"
    />
  </div>
</template>

<style scoped lang="scss" src="./templateFrameOptionDisplays.scss"></style>
